
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bar-and-restaurant",
      function () {
        return require("private-next-pages/bar-and-restaurant.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bar-and-restaurant"])
      });
    }
  